// extracted by mini-css-extract-plugin
export default {"container":"date-range_container__MW3Xg","delimiter":"date-range_delimiter__cXpOG"};